<!-- @component Adds Open Graph <meta> tags to page. -->
<script lang="ts">
  import { SOCIAL_IMAGE } from "$lib/core/social-image";

  interface Props {
    title?: string;
    description?: string;
    imageUrl?: string;
  }

  let {
    // The fallback og:title and og:description values are intentionally kept
    // short to avoid being repetitive when linking dashboard pages.
    title = "Modal",
    description = "AI infrastructure that developers love.",
    imageUrl = SOCIAL_IMAGE.url,
  }: Props = $props();

  const isDefaultSocialImage = $derived(imageUrl === SOCIAL_IMAGE.url);
</script>

<svelte:head>
  <!-- HTML Meta tags -->
  <meta name="description" content={description} />

  <!-- Opengraph -->
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Modal" />
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  {#if imageUrl}
    <meta property="og:image" content={imageUrl} />
  {/if}
  {#if isDefaultSocialImage}
    <meta property="og:image:width" content={String(SOCIAL_IMAGE.width)} />
    <meta property="og:image:height" content={String(SOCIAL_IMAGE.height)} />
    <meta property="og:image:alt" content={SOCIAL_IMAGE.alt} />
  {/if}

  <!-- Twitter. Only declare a card when there is an image: a card without
       one makes Slack render an empty image placeholder in the unfurl. -->
  {#if imageUrl}
    <meta name="twitter:card" content="summary_large_image" />
  {/if}
  {#if isDefaultSocialImage}
    <meta name="twitter:image" content={SOCIAL_IMAGE.url} />
    <meta name="twitter:image:alt" content={SOCIAL_IMAGE.alt} />
  {/if}
</svelte:head>
